import { Collapse } from 'antd';
import styled from 'styled-components';

export const Container = styled(Collapse)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.primary};
  .ant-collapse-content {
    background-color: ${(props) => props.theme.colors.primary};
  }
`;
